module.exports = __webpack_public_path__ + "img/teamImg31.e770338e.jpg";